<template>
  <div class="face-webrtc">
    <!-- <div class="ing-tip">{{ flag ? '正在录制中' : '录制完成' }}</div> -->
    <div class="ing-tip">
      <template v-if="videoState === 'ready'">请准备, {{ readyTime }}秒后开始录制</template>
      <template v-else-if="videoState === 'playing'">正在录制中...</template>
      <template v-else-if="videoState === 'done'">录制完成</template>
    </div>
    <div class="video-wrap">
      <video ref="videoRef" id="face_video" autoplay object-fit="cover" playsinline></video>

      <div class="circle"></div>
    </div>

    <div class="agree-box">
      <div class="small-title">
        操作时请您配合
      </div>
      <ul class="ul-list">
        <li>请允许使用手机摄像头</li>
        <li>请调亮手机屏幕亮度，确保光线充足</li>
        <li>请保持正脸对准屏幕，确保人脸完整清晰</li>
        <li>请确保真实本人操作</li>
        <li>5秒后自动结束录制</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import Api from '@/api'

export default {
  components: {},
  data() {
    return {
      videoState: 'ready', // ready, playing, done
      readyTime: 3,
      duration: 5,
      videoType: 'video/webm',
    }
  },

  created() {
    // 判断MediaRecorder支持的视频类型
    if (window.MediaRecorder.isTypeSupported('video/webm')) {
      this.videoType = 'video/webm'
    } else if (window.MediaRecorder.isTypeSupported('video/mp4')) {
      this.videoType = 'video/mp4'
    } else {
      console.log('不支持视频流')
      // this.$router.replace('/authentication/face/faceSecond')
    }
  },

  mounted() {
    this.initGetUserMedia()
  },
  methods: {
    initGetUserMedia() {
      const constraints = {
        video: {
          width: 480,
          height: 480,
          frameRate: 25,
          facingMode: 'user',
          videoType: this.videoType,
        },
      }

      navigator.mediaDevices.getUserMedia(constraints).then((camera) => {
        const video = this.$refs.videoRef
        video.muted = true;
        video.volume = 0;

        if ('srcObject' in video) {
          video.srcObject = camera;
        } else {
          video.src = window.URL.createObjectURL(camera)
        }
        video.play()

        // 存储录制的视频块
        const recordedChunks = []

        // 创建录制器
        const recorder = new window.MediaRecorder(camera, {
          mimeType: this.videoType,
          videoWidth: 480,
          videoHeight: 480,
        })

        // 监听数据可用事件
        recorder.ondataavailable = event => {
          if (event.data.size > 0) {
            console.log('event-size: ', event.data.size / 1024 / 1024)
            recordedChunks.push(event.data)
          }
        }

        // 监听录制开始
        recorder.onstart = () => {
          const timer = setTimeout(() => {
            recorder.stop()
            clearTimeout(timer)
          }, this.duration * 1000);
        }

        // 监听停止录制
        recorder.onstop = () => {
          this.videoState = 'done'
          // 创建 Blob 对象
          const blob = new Blob(recordedChunks, { type: this.videoType })

          // 使用 FileReader 将 Blob 转换为 base64
          const reader = new FileReader()
          reader.readAsDataURL(blob)

          reader.onloadend = () => {
            this.$toast.loading({
              message: '正在验证中...',
              overlay: true,
              forbidClick: true,
              loadingType: 'spinner',
              duration: 0,
            })

            const base64data = reader.result
            const { taskId, userId } = this.$route.query
            const param = {
              taskId,
              userId,
              videoType: this.videoType.split('/')[1],
              videoBase64: base64data.replace(`data:${this.videoType};base64,`, ''),
            }

            Api.livenessVerifyUrl(param).then(() => {
              this.$toast.clear()
              this.$router.replace({
                path: '/authentication/face/webrtc_result',
                query: this.$route.query,
              })
            }).catch(err => {
              // console.log('err: ', err)
              this.$router.back()
              // this.$router.replace({
              //   path: '/authentication/face/webrtc_result',
              //   query: this.$route.query,
              // })
            })

          }
        }

        // 开始录制
        let readyTimer = setInterval(() => {
          this.readyTime--
          if (this.readyTime === 0) {
            recorder.start()
            this.videoState = 'playing'
            clearInterval(readyTimer)
            readyTimer = null
          }
        }, 1000);

      }).catch(error => {
        console.log('-----: ', error)
        let errorTxt = ''
        if (error.name === 'NotAllowedError') {
          errorTxt = '您拒绝了访问摄像头的请求。请退出重新进入'
        } else if (error.name === 'NotFoundError') {
          errorTxt = '没有找到任何可用的媒体设备。'
        } else if (error.name === 'NotSupportedError') {
          errorTxt = '浏览器不支持媒体设备。'
        } else if (error.name === 'NotReadableError') {
          errorTxt = '无法打开摄像头。'
        } else if (error.name === 'OverconstrainedError') {
          errorTxt = '指定的约束无法满足。'
        } else if (error.name === 'SecurityError') {
          errorTxt = '安全错误。'
        } else if (error.name === 'TypeError') {
          errorTxt = '设备请求类型错误'
        } else {
          errorTxt = '未知错误'
        }

        Dialog.alert({
          message: errorTxt,
        }).then(() => {
          this.$router.back()
        });
      });

    },
  },

  // 清除定时器
  beforeDestroy() {
    const video = this.$refs.videoRef
    if ('srcObject' in video) {
      video.srcObject = null;
    } else {
      video.src = null
    }
    this.$toast.clear()
  }
}
</script>

<style lang="less" scoped>
.face-webrtc {
  display: table;
}

.ing-tip {
  margin-top: 40px;
  // margin-bottom: 24px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: #111a34;
}

.timer {
  font-size: 14px;
  color: #111a34;
  text-align: center;
}

.video-wrap {
  position: relative;
  width: 100vw;
  height: 75vw;
  background-color: white;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
  }
}

.circle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 220px;
  /* 圆的直径 */
  height: 220px;
  /* 圆的直径 */
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0);
  /* 圆形透明 */
  box-shadow: 0 0 0 100vw white;
  /* 圆形之外的部分为白色 */
  // box-shadow: 0 0 0 100vw rgba(255, 255, 255, 0.3);
  /* 圆形之外的部分为白色 */
  z-index: 1;
}

.agree-box {
  margin: 24px;
  margin-top: 24px;

  .small-title {
    font-size: 12px;
    color: #677283;
    font-weight: 500;
    line-height: 1.5em;
    margin-bottom: 4px;
  }

  .ul-list {
    li {
      font-size: 12px;
      font-weight: 400;
      display: flex;
      align-items: center;
      color: #677283;
    }

    li::before {
      content: '•';
      color: #1676ff;
      margin-right: 8px;
      font-size: 18px;
    }
  }
}
</style>
